export default __webpack_public_path__ + "static/media/img-ovato-horse.8844ac0c.png";